import React, { useState } from "react";
import { css, cx } from "emotion";

import { fontSize16 } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../../js/shared/new-theme";

const SeeMore = ({ children }) => {
	const cardInfo = `
        display: flex;
        flex-direction: column;
        width: 100%; 
        padding: 24px 0;
        flex-direction: column;
        height: 155px;
        overflow: hidden;
        position: relative;
				margin-bottom: 24px;

        & strong {
            font-size: ${fontSize16};
            padding: 8px 0;
        }
        & p {
            font-size: 14px;
        }
    `;

	const cardInfoFull = `	
        height: initial;
    `;

	const seeMore = `
        font-size: 14px;
        font-weight: bold;
        color: ${theme.palette.gray[800].value};
        position: absolute;
        bottom: 0;
        background-color: ${theme.palette.common.white};
        width: 100%;
        text-align: center;
        padding: 4px 8px 8px;
        box-shadow: ${theme.shadows[100]};
    `;

	const [hasSeeMore, handleSeeMore] = useState(false);

	return (
		<div
			className={cx(
				css`
					${cardInfo};
				`,
				{
					[css`
						${cardInfoFull};
					`]: hasSeeMore
				}
			)}
		>
			{children}

			{!hasSeeMore && (
				<div
					className={css`
						${seeMore};
					`}
					onClick={ev => handleSeeMore(true)}
				>
					Ver mais
				</div>
			)}
		</div>
	);
};

export default SeeMore;
